<template>
  <div ref="jbsDropdownMenu" class="jbs-dropdown-menu">
    <div v-if="this.$parent.showDropdown == true">
      <ul>
          <slot></slot>
      </ul>
    </div>
  </div>
</template>

<script>
import jbsCard from "@/custom-components-test/jbsCard.vue"

export default {
    components:{
     jbsCard
    },
    mounted(){
            this.$parent.$watch( "showDropdown", (new_value) => {

               this.calculatePositon();
              }
    );
  },
    methods:{
     calculatePositon(){
      var widthOfChild = this.$refs.jbsDropdownMenu.offsetWidth;
      var widthOfParent = this.$parent.$refs.dropdownParent.offsetWidth;
      var childWiderOfParent = widthOfChild - widthOfParent;
      var position = this.$parent.$refs.dropdownParent.getBoundingClientRect().left;
      if(childWiderOfParent > 0){
          position -= childWiderOfParent;
      }
      this.$refs.jbsDropdownMenu.style = `left:${position}px`;
     }
    }
}
</script>

<style scoped>

.jbs-dropdown-menu{
    position: absolute;
    background: #FFFFFF;
    border: 1px solid #DFE0EB;
    box-sizing: border-box;
    border-radius: 5px;
    margin: 5px;
}

ul{
    list-style: none;
    margin: 7px 0px;
    padding: 0;
}
</style>